<script setup lang="ts">
const router = useRouter();

const routePath = computed(() => router.currentRoute.value.path);

const { width } = useWindowSize();
const isDesktop = computed(() => {
	return width.value >= 1024;
});
</script>

<template>
	<div :class="!isDesktop ? 'is-mobile' : ''" class="e-footer">
		<div :class="!isDesktop ? 'is-hidden' : ''" class="navigation-container">
			<NuxtLink
				id="terms-of-sale-link"
				to="/terms-of-sale"
				class="menu-item text-normal"
				:class="{ 'is-active': routePath.includes('terms-of-sale') }"
			>
				{{ $t('termsOfSale') }}
			</NuxtLink>

			<NuxtLink
				id="terms-of-use-link"
				to="https://shop.vnggames.com/card/terms-of-service"
				class="menu-item text-normal"
			>
				{{ $t('termsOfUse') }}
			</NuxtLink>

			<NuxtLink
				id="privacy-policy-link"
				to="https://shop.vnggames.com/card/privacy-policy"
				class="menu-item text-normal"
			>
				{{ $t('privacyPolicy') }}
			</NuxtLink>
		</div>

		<div class="brand-container">
			<div class="logo">
				<div />
				<img class="vnggames-logo" src="/images/vnggames-logo.png" alt="VNGGames Logo" />
			</div>
			<div class="copyright">
				<p>Copyright of VNG Singapore</p>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
@import '@/assets/scss/components/footer.scss';
</style>
